module.exports = __webpack_public_path__ + "img/childentry.696da3f2.png";